import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { getFileIcon } from "../../../../../../components/fileinformation";
import {
  downloadAttachments,
  getImage,
} from "../../../../../../utilities/storageOperations/downloadURL";
import FileDownloader from "../OfferCard/FileDownloader/FileDownloader";
import { getFileFormat } from "../OfferCard/FileDownloader/utils";
import "./styles.css";

const AttachmentContainer = ({ fileName, filePath }) => {
  const dispatch = useDispatch();

  // const [link, setLink] = useState(null);
  // useEffect(() => {
  //   (async () => {
  //     const response = await getImage(fileName);
  //     console.log({ response });
  //     setLink(response);
  //   })();
  // }, [fileName]);
  return (
    <div
      className="attachment-container-msg"
      onClick={() => {
        // downloadAttachments(filePath?.substring(15)).then((result) => {
        //   console.log("result----->", result);
        //   window.open(result);
        // });
        window.open(`${process.env.REACT_APP_S3_URL}/${filePath}`)
      }}
    >
      {/* <a href={link} download={fileName} target="_blank"> */}
        <div className="attachment-content-msg">
          <img
            src={getFileIcon(getFileFormat(fileName))}
            // alt={fileName}
            className="fileIcon-msg"
          />
          <div className="attachment-content-info-msg">
            <h3>{fileName}</h3>
            <p>{getFileFormat(fileName)}</p>
          </div>
        </div>
      {/* </a> */}
    </div>
  );
};
export default AttachmentContainer;
